import bedStatusService from "../../services/bedStatus";

import { logger } from "../../utils/logger";
import { AppDispatch } from "../store";
import { bedStatusSlice } from "./slice";
const { actions: slice } = bedStatusSlice;

export const getBedStatus = () => {
  return async (dispatch: AppDispatch) => {
    try {
      const res = await bedStatusService.get();
      console.log(res);
      const WARD = res.data.data.find((item: { type: string; }) => item.type === "WARD")
      const ICU = res.data.data.find((item: { type: string; }) => item.type === "ICU")

      dispatch(slice.setWARDStatus(WARD));
      dispatch(slice.setICUStatus(ICU));
      // dispatch(slice.updateBed(res.data.data));
      return Promise.resolve(res.data.data);
    } catch (error) {
      logger.error({ error: error });
      return Promise.reject(error);
    }
  };
};

export const setBedStatusEmptyAction = () => (dispatch: AppDispatch) => {
  dispatch(slice.setBedStatusEmpty());
};
